module.exports = __webpack_public_path__ + "img/logo-light-nightskyes.e7a8d14e.png";